module.exports = __webpack_public_path__ + "img/symbol_5.9bf563cf.png";